import type { ReactNode } from 'react';
import { cn } from './components/utils';

export function PageInset({ children }: { children: ReactNode }) {
	return <div className="relative flex min-h-0 flex-1">{children}</div>;
}

function PageInsetNav({ children }: { children: ReactNode }) {
	return <div className={cn('absolute inset-y-0 left-0 w-[240px] overflow-y-auto border-r border-gray-200 bg-white')}>{children}</div>;
}

function PageInsetBody({ children }: { children: ReactNode }) {
	return <div className="absolute inset-y-0 left-[240px] right-0 overflow-y-auto">{children}</div>;
}

PageInset.Nav = PageInsetNav;
PageInset.Body = PageInsetBody;
